import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { CalculatedSplitBookingPrice } from 'components/Offer/types';
import { getCurrencyCode } from 'modules/meta/selectors';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Price } from '@daedalus/atlas/Price';
import { Text } from '@daedalus/atlas/Text';
import { getRoundingStrategy } from '@daedalus/core/src/utils/number';
import { messages } from '../messages';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1p18wv2",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => Flex.Row;
const PriceBreakdown = /*#__PURE__*/styled(_exp2())({
  name: "PriceBreakdown",
  class: "pqjvn9u",
  propsAsIs: true
});
const _exp5 = /*#__PURE__*/() => Text;
const NightsRoomsGuestsMessage = /*#__PURE__*/styled(_exp5())({
  name: "NightsRoomsGuestsMessage",
  class: "n1khq6fx",
  propsAsIs: true
});
interface Props {
  numberOfNights: number;
  numberOfRooms: number;
  numberOfGuests: number;
  splitBookingRateInfo: CalculatedSplitBookingPrice;
}
export const SplitBookingDetailsPriceBreakdown: React.FC<Props> = ({
  numberOfNights,
  numberOfRooms,
  numberOfGuests,
  splitBookingRateInfo
}) => {
  const {
    formatMessage
  } = useIntl();
  const currencyCode = useSelector(getCurrencyCode);
  return <Wrapper>
      <PriceBreakdown className=" __extraMargin" justifyContent="space-between" alignItems="center">
        <Text>{formatMessage(messages.avgHeading)}</Text>
        <Text>
          <Price noStyle value={splitBookingRateInfo.average} currency={currencyCode} roundingStrategy={getRoundingStrategy()} />
        </Text>
      </PriceBreakdown>
      <PriceBreakdown justifyContent="space-between" alignItems="center">
        <Text variant="titleM">{formatMessage(messages.totalPrice)}</Text>
        <Text variant="titleM">
          <Price noStyle value={splitBookingRateInfo.sum} currency={currencyCode} roundingStrategy={getRoundingStrategy()} />
        </Text>
      </PriceBreakdown>
      <PriceBreakdown justifyContent="space-between" alignItems="center">
        <NightsRoomsGuestsMessage variant="bodyS" colorPath="content.neutral.c600">
          <span>
            {numberOfNights}{' '}
            {formatMessage(messages.nights, {
            count: numberOfNights
          })}
          </span>
          <span>, </span>
          <span>
            {numberOfRooms}{' '}
            {formatMessage(messages.rooms, {
            count: numberOfRooms
          })}
          </span>
          <span>, </span>
          <span>
            {numberOfGuests}{' '}
            {formatMessage(messages.guests, {
            count: numberOfGuests
          })}
          </span>
        </NightsRoomsGuestsMessage>
        <Text align="right">
          <Text variant="bodyS" colorPath="content.neutral.c600">
            {formatMessage(messages.includingTaxes)}
          </Text>
        </Text>
      </PriceBreakdown>
    </Wrapper>;
};

require("./SplitBookingDetailsPriceBreakdown.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SplitBookingDetailsPriceBreakdown.tsx");